import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Article from '../components/article';
import Layout from '../layouts/default-layout';
import SEO from '../components/seo';
import useSiteMetadata from '../hooks/use-site-metadata';
var BrandHeartPage = function BrandHeartPage(_ref) {
    var location = _ref.location;
    var _useSiteMetadata = useSiteMetadata(), siteURL = _useSiteMetadata.siteURL;
    var canonicalUrl = "" + siteURL + location.pathname;
    var pageTitle = 'Brand Messaging';
    var articles = [
        {
            articleTitle: 'Our Brand Truths',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-between"
            }, /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "1. Guidance"), /*#__PURE__*/ React.createElement("p", null, "Healing Box takes the guesswork out of self-care with vetted products and expert care teams to solve for personal health and wellness issues."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "We provide support to help you make informed decisions to successfully manage your health.")), /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "2. Accessibility"), /*#__PURE__*/ React.createElement("p", null, "Healing Box makes high-quality self-care readily available and tailored to every life stage."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "We are committed to bringing prestigious, quality, safe, mission-driven, evidence-based products and digital health services directly to you."))), /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-between"
            }, /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5 mb-md-0"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "3. Platform"), /*#__PURE__*/ React.createElement("p", null, "Healing Box is a modern self-care marketplace bridging health care, wellness and beauty in one place."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "Our comprehensive platform helps put a curated self-care experience and community at the center of everything you do.")), /*#__PURE__*/ React.createElement(Col, {
                sm: 6
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "4. Social Responsibility"), /*#__PURE__*/ React.createElement("p", null, "Healing Box advocates for positive change - from our sustainable products to challenging health disparities and building representation in health and wellness."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "Together, we can move towards a simpler, safer and more equitable wellness space that enables better choices\u2014for our health, our communities and the world."))))
        },
        {
            articleTitle: 'Brand Idea',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
                className: "display-3 mb-5 text-center"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Deliver"), /*#__PURE__*/ React.createElement("sup", null, "\xB9"), " on the ", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "promise"), /*#__PURE__*/ React.createElement("sup", null, "\xB2"), " of ", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "true self-care."), /*#__PURE__*/ React.createElement("sup", null, "\xB3")), /*#__PURE__*/ React.createElement("span", {
                className: "small text-center"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, "1. Build a habit."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, "2. Our pursuit to make right."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "3. From trendy conventions to healing practices.")))
        },
        {
            articleTitle: 'Brand Manifesto',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
                className: "display-4 text-serif"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-5"
            }, "We see how much you care. It's in everything you do."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-5"
            }, "The long nights, the hard work, the way you keep on showing up\u2014for your people and your dreams."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-5"
            }, "Your care is your superpower. It fuels your work, your relationships, your life. But your fuel has to come from somewhere. And that somewhere? It's you."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-5"
            }, "We want to help you care for yourself the way you care for everything that matters: with passion, with diligence and with genuine heart for the journey ahead."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "Because here's the secret no one else will tell you: when you give your best to yourself, you can give your best to the world.")))
        },
        {
            articleTitle: 'Tagline',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
                className: "display-2 mb-5 text-center"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Open"), /*#__PURE__*/ React.createElement("sup", null, "\xB9"), " to ", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Something New."), /*#__PURE__*/ React.createElement("sup", null, "\xB2")), /*#__PURE__*/ React.createElement("p", {
                className: "text-center large mb-5"
            }, "The idea of \u201Copenness\u201D is the mindset we want audience to have. It\u2019s aspirational, inclusive and intriguing. It nods to the fact that joining Healing Box is a journey, an adventure, a process.", ' '), /*#__PURE__*/ React.createElement("span", {
                className: "small text-center"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, "1. An invitation to a new way of thinking about caring for yourself."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "2. The promise of something new - and maybe better. Leaves room for Healing Box to grow and evolve.")))
        },
        {
            articleTitle: 'Brand Strategy',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
                className: "border-top border-bottom py-5"
            }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 4
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3 mb-xl-0"
            }, "Our brand vision")), /*#__PURE__*/ React.createElement(Col, {
                md: 8
            }, /*#__PURE__*/ React.createElement("p", {
                className: "large text-serif mb-0"
            }, "A world where self-care is foundational to health.")))), /*#__PURE__*/ React.createElement("div", {
                className: "border-bottom py-5"
            }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 4
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3 mb-xl-0"
            }, "Our brand mission")), /*#__PURE__*/ React.createElement(Col, {
                md: 8
            }, /*#__PURE__*/ React.createElement("p", {
                className: "large text-serif mb-0"
            }, "To help people be active agents in their healthcare and build a practice of self-care with the right tools at the right time of their life.")))), /*#__PURE__*/ React.createElement("div", {
                className: "border-bottom py-5"
            }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 4
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3 mb-xl-0"
            }, "Our brand idea")), /*#__PURE__*/ React.createElement(Col, {
                md: 8
            }, /*#__PURE__*/ React.createElement("p", {
                className: "text-serif large mb-0"
            }, "Deliver on the promise of true self-care")))), /*#__PURE__*/ React.createElement("div", {
                className: "pt-5"
            }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3"
            }, "Who we are"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "We are an evidence-based wellness company who believes self-care is necessary pillar to health.")), /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3"
            }, "Our purpose"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "Help people build rituals to put themselves first.")), /*#__PURE__*/ React.createElement(Col, {
                sm: 6,
                className: "mb-5 mb-md-0"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3"
            }, "What we offer"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, "We're an online self-care marketplace for evidence-based, carefully curated wellness products & mission-driven brands. We provide support for the unknowns of every phase of life.")), /*#__PURE__*/ React.createElement(Col, {
                sm: 6
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder text-capitalize mb-3"
            }, "How we do it"), /*#__PURE__*/ React.createElement("ul", {
                className: "m-0 pl-3"
            }, /*#__PURE__*/ React.createElement("li", {
                className: "mb-1"
            }, "Trustworthy"), /*#__PURE__*/ React.createElement("li", {
                className: "mb-1"
            }, "Support"), /*#__PURE__*/ React.createElement("li", {
                className: "mb-1"
            }, "Balance"), /*#__PURE__*/ React.createElement("li", {
                className: "mb-0"
            }, "Representation"))))))
        },
        {
            articleTitle: 'Brand Archetype',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "Who is Healing Box?"), /*#__PURE__*/ React.createElement("p", {
                className: "text-serif large line-height-large mb-5"
            }, "Healing Box is a ", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "trustworthy"), " and", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "wise older sister."), " She has high standards and wants what\u2019s best for you\u2014", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "on your terms,"), " of course. She loves discovering amazing new products and chatting up their benefits with anyone who will listen. She\u2019s always happy to", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "offer a personalized reco"), " or point you in the right direction. But she actually hopes you\u2019ll fall in love with wellness, too, and join her in", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "exploring the wild world of self-care.")), /*#__PURE__*/ React.createElement("h3", {
                className: "h6 font-weight-bolder mb-3"
            }, "Who is Healing Box NOT?"), /*#__PURE__*/ React.createElement("p", {
                className: "text-serif large line-height-large mb-0"
            }, "Healing Box is ", /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "not a \u201Cguru\u201D"), " hawking questionable potions or powders. And she", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "isn\u2019t an airbrushed,"), " influencer out to sell you on her enviable glow. She\u2019s", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "not an unattainable lifestyle brand,"), ' ', "demanding a high price for admission. And she\u2019s not a one-size-fits-all solution or the latest \u201Cquick-fix\u201D scam. She isn\u2019t self promotional or one-dimensional. She\u2019s", ' ', /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "not perfect or performative."), " And she\u2019s most certainly not borrowed relevance in a made-for-IG trend (#selfcare, #blessed)."))
        },
        {
            articleTitle: 'Brand Voice/Tone',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "display-4 text-serif mb-4"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Clear"), " but not over-simplified."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We sound like\u2026"), ' ', "everything you need to know, streamlined."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We don\u2019t sound like\u2026"), ' ', "fluff, jargon, or woo-woo marketing speak.")), /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "display-4 text-serif mb-4"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Relatable"), " but not overly friendly."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We sound like\u2026"), " we \u201Cget\u201D you and your life."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We don\u2019t sound like\u2026"), " a brand who is trying to be a person."))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "display-4 text-serif mb-4"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Well-informed"), " but not clinical."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We sound like\u2026"), " a friend who gives good advice."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We don\u2019t sound like\u2026"), " a textbook")), /*#__PURE__*/ React.createElement(Col, {
                md: 6,
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "display-4 text-serif mb-4"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Encouraging"), " but not overly enthusiastic."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We sound like\u2026"), " a coach who is in your corner."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We don\u2019t sound like\u2026"), " a cheerleader."))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
                md: 6
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "display-4 text-serif mb-4"
            }, /*#__PURE__*/ React.createElement("u", {
                className: "font-italic"
            }, "Smart"), " but not smart-mouthed."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-3 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We sound like\u2026"), " wit or a wink when it makes sense."), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0 line-height-small"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "font-weight-bold"
            }, "We don\u2019t sound like\u2026"), ' ', "we\u2019re throwing puns or trying too hard."))))
        }
    ];
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), articles.map(function (item, index) {
        var itemKey = "article-" + index;
        return /*#__PURE__*/ React.createElement(Article, {
            title: item.articleTitle,
            pageUrl: canonicalUrl,
            key: itemKey
        }, item.articleContent);
    }));
};
export default BrandHeartPage;
